import { memo } from "react";
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemTitle,
} from "@volca/ui/components/ui/item";
import { cn } from "@volca/ui/lib/utils";
import { formatRelativeTime } from "@/core/utils/date";
import { getCustomerNameOrPhone } from "@/customer/utils";
import { IMostRecentTextMessage } from "@/text-messages/text-messages";

interface TextMessageListItemProps {
  textMessage: IMostRecentTextMessage;
  onSelect: (textMessage: IMostRecentTextMessage) => void;
  isSelected: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const TextMessageListItem = memo(
  ({
    textMessage,
    onSelect,
    isSelected,
    onMouseEnter,
    onMouseLeave,
  }: TextMessageListItemProps) => (
    <Item
      render={<button type="button" />}
      aria-current={isSelected ? "true" : undefined}
      className={cn("text-left", { "bg-selected": isSelected })}
      onClick={() => onSelect(textMessage)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <ItemContent>
        <ItemTitle>
          {getCustomerNameOrPhone(textMessage.customer)}
          <span className="font-normal text-subtle">
            {formatRelativeTime(textMessage.created_at)}
          </span>
        </ItemTitle>
        <ItemDescription className="text-ink">
          {textMessage.body ||
            `${textMessage.media_urls.length} attachment${textMessage.media_urls.length > 1 ? "s" : ""}`}
        </ItemDescription>
      </ItemContent>
    </Item>
  ),
);
